import StatusBadge from "components/StatusBadge/StatusBadge";
import { Execution } from "graphql/generated/graphql";
import { statusColors, statusLabels } from "utils/utils";

export const ExecutionStatusBadge = ({
    data,
    size = "large",
}: {
    data?: Execution;
    size?: string;
}) => {
    if (!data) return null;

    const { type, status } = data;
    const isConnectionExecutionFailed = type === "CONNECTION" && status === "ENDED_ERROR";
    return (
        <StatusBadge
            darkText={isConnectionExecutionFailed}
            size={size}
            text={status ? statusLabels[status] : undefined}
            type={
                isConnectionExecutionFailed ? "primary-pink" : (status && statusColors[status]) || "hover-grey"
            }
        />
    );
};
